import { render } from "./DisplayChart.vue?vue&type=template&id=0475bea0"
import script from "./DisplayChart.vue?vue&type=script&lang=js"
export * from "./DisplayChart.vue?vue&type=script&lang=js"

import "./DisplayChart.vue?vue&type=style&index=0&id=0475bea0&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__